import { Form, Select } from "antd";
import { useTranslation } from "react-i18next";

import { extractModelFromPath } from "@/modules/model";
import { Tag } from "@/ui/tag";

import { useGetRolesList } from "./UserRolesBehaviorSelect.query";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

const UserRolesBehaviorSelect = () => {
  const { t } = useTranslation();
  const { roles } = useGetRolesList();

  return (
    <Form.Item
      name="behavior"
      label={t("user:role")}
      rules={[{ required: true }]}
    >
      <Select allowClear>
        {roles
          .filter((r) => r)
          .map((role) => (
            <Option key={role} value={role}>
              <Tag>{t(`role:${extractModelFromPath(role)}`)}</Tag>
            </Option>
          ))}
      </Select>
    </Form.Item>
  );
};

export default UserRolesBehaviorSelect;
